export const getTotalMoney = (orderItems, services) =>
  orderItems.reduce((total, orderItem) => {
    if (!orderItem.serviceId) return total;
    const service = services.find((sv) => sv.id === orderItem.serviceId);
    return total + (service.price - parseInt(orderItem.discount || 0, 10));
  }, 0);
